import {
  SingleValueCookie,
  MultiValueCookie,
  cookieExists,
} from 'saddlebag-cookie';
import { getPreferences, PREFERENCES } from 'saddlebag-tracking-preferences';

const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

// The cookie store API expects an integer number of days, but the metadata
// provides maxAge in milliseconds.
const maxAgeToDays = (maxAge) => Math.ceil(maxAge / MILLISECONDS_PER_DAY);

const writeCookie = ({ maxAge, name, value }) => {
  // Never overwrite a cookie that has already been written.
  if (cookieExists(name)) {
    return;
  }

  // Multi-value cookies (e.g. ssaboverrides) carry an array of { name, value } pairs
  if (Array.isArray(value)) {
    const cookie = new MultiValueCookie(name);
    value.forEach((pair) => cookie.setValue(pair.name, pair.value));
    cookie.store(maxAgeToDays(maxAge));
    return;
  }

  if (value) {
    new SingleValueCookie(name).setValue(value).store(maxAgeToDays(maxAge));
  }
};

export const syncExperimentationCookies = (data) => {
  const cookieMetadata = data.experimentationCookieMetadata || [];
  const trackingPreferences = getPreferences(data.culture.market);

  if (trackingPreferences[PREFERENCES.INFORMATION]) {
    cookieMetadata.forEach(writeCookie);
  }
};
